<div *ngIf="olLayer">
  <div *ngIf="HsLayerEditorService.legendVisible()"><!-- TODO: Remove function call from template -->
    <p style="text-align: center; font-weight: bold">
      {{ "COMMON.legend" | translateHs }}
    </p>
    <hs-legend-layer-directive [layer]="HsLayerEditorService.legendDescriptor">
    </hs-legend-layer-directive>
    <hr />
  </div>
</div>